import React, { useEffect } from "react";
import swamijiImage from "../assets/images/swamiji--270x270.jpg";
import ScrollReveal from "scrollreveal";
const AboutSwamiji = () => {
  
  useEffect(() => {
    ScrollReveal().reveal(".reveal-left", {
      duration: 2000, // Animation duration (in ms)
      distance: "100px", // Distance the element moves
      origin: "left", // Animation starts from the left
      easing: "ease-in-out", // Easing function
      reset: true, // Reset the animation when scrolling back
    });

    ScrollReveal().reveal(".reveal", {
      duration: 2000, // Animation duration (in ms)
      distance: "100px", // Distance the element moves
      origin: "bottom", // Animation starts from the left
      easing: "ease-in-out", // Easing function
      reset: true, // Reset the animation when scrolling back
    });
  }, []);

  return (
    <div
      className="container-sm"
      style={{ ...styles.container, minHeight: "100vh", }}
    >
      {/* Image Section */}
      <div className="reveal-left" style={styles.imageContainer}>
        <img
          src={swamijiImage} // Replace with your image URL
          alt="Swamiji"
          style={styles.image}
        />
      </div>

      {/* Text Section */}
      <div className="reveal" style={styles.textContainer}>
        <p>
          <span style={{ fontWeight: "bold", color: "orange" }}>
            <span style={{ fontSize: "28px" }}>S</span>wami Paramārthānanda
          </span>{" "}
          is the Founder and Managing Trustee of The Vedanta Vidyarthi Sangha
          Trust (VVS). Swamiji conducts classes and discourses on Vedanta under
          the auspices of this Trust.
        </p>
        <p>
          Swami Paramārthānanda was born on 18-05-1953 to Subramania Iyer and
          Parvathy in Palakkad, Kerala. He grew up with three older siblings and
          had his early schooling and college education in Palakkad, his home
          town.
        </p>
        <p>
          In the year 1976 Swamiji joined a three year course in Vedānta offered
          by his Guru Swami Dayananda Saraswati at Sandeepany Sadhanālaya,
          Mumbai. There, he studied Sanskrit and the Sastras like the
          Bhagavadgītā, principal Upaniṣads, Brahmasūtras and several
          Prakaraṇagranthas. After the completion of his course he moved to
          Chennai as a Brahmachāri on the directive of his Guru and started
          teaching Vedānta. He received Sannyāsa from his Guru in the year 1984
          and continues to live in Chennai and teach at various centres in the
          city.
        </p>
        <p>
          Over the last four decades Swamiji has systematically given public
          classes in English on several texts in Vedānta; ie Bhagavadgītā,
          principal Upaniṣads, Brahmasūtras and Prakaraṇagranthas like
          Pañcadaśī, Naiṣkarmyasiddhi, Upadeśasāhasrī and several more.
          Swamiji’s methodology of teaching involves communicating in English
          the essence of every Sanskrit verse in a text. He has also conducted
          classes in Sanskrit. On behalf of Vedanta Vidyarthi Sangha Trust
          Swamiji’s talks are digitally recorded, mastered, archived and
          streamed by Yogamalika LLC and Mantra. These recordings are very
          useful for those who cannot physically attend his lectures.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // padding: "20px",
    gap: "20px", // Space between image and text
    flexWrap: "wrap", // Wraps on smaller screens
    marginTop: "0px"
  },
  imageContainer: {
    flex: "1 1 40%", // Image takes 40% width
    display: "flex",
    // maxWidth: "350px",
    minWidth: "350px",
    justifyContent: "center", // Center the image horizontally
  },
  textContainer: {
    flex: "1 1 50%", // Text takes 50% width
    textAlign: "left", // Align text to the left
  },
  image: {
    width: "80%", // Ensures the image is responsive
    height: "auto",
    borderRadius: "8px",
    boxShadow: "2px 5px 10px #000",
    cursor: "pointer",
  },
  // Media Query for Small Screens
  "@media (max-width: 768px)": {
    container: {
      flexDirection: "column", // Stacks items vertically
    },
    imageContainer: {
      marginBottom: "20px", // Adds space between image and text
    },
  },
};

export default AboutSwamiji;
